/** BetBond admin console design tokens — aligned with consumer app theme. */
export const ADMIN_THEME = {
  background: "#0A0F18",
  surface: "#141B26",
  surfaceLight: "#1A2332",
  surfaceLighter: "#1F2B3F",
  primary: "#1E88E5",
  primaryLight: "#64B5F6",
  primaryDark: "#1565C0",
  secondary: "#2979FF",
  success: "#2ECC71",
  successLight: "#4CAF50",
  error: "#EF5350",
  errorLight: "#F44336",
  warning: "#FFCA28",
  warningLight: "#FF9800",
  inactive: "#95a5a6",
  text: {
    primary: "#FFFFFF",
    secondary: "rgba(255, 255, 255, 0.7)",
    tertiary: "rgba(255, 255, 255, 0.5)",
    muted: "rgba(255, 255, 255, 0.4)",
  },
  border: {
    light: "rgba(30, 136, 229, 0.12)",
    medium: "rgba(30, 136, 229, 0.2)",
    dark: "rgba(30, 136, 229, 0.3)",
  },
  shadow: {
    light: "0 1px 3px rgba(0, 0, 0, 0.3)",
    medium: "0 4px 6px rgba(0, 0, 0, 0.4)",
    heavy: "0 10px 25px rgba(0, 0, 0, 0.5)",
  },
  opacity: {
    light: 0.12,
    medium: 0.2,
    high: 0.3,
  },
  shell: {
    pageBg:
      "linear-gradient(165deg, #060910 0%, #0a0f18 35%, #0c1420 70%, #070b12 100%)",
    sidebarBg:
      "linear-gradient(180deg, rgba(14, 20, 32, 0.96) 0%, rgba(8, 12, 20, 0.98) 100%)",
    headerBg:
      "linear-gradient(180deg, rgba(18, 24, 36, 0.92) 0%, rgba(12, 17, 26, 0.88) 100%)",
    headerBorder: "rgba(30, 136, 229, 0.18)",
    headerShadow:
      "0 8px 32px rgba(0, 0, 0, 0.45), inset 0 -1px 0 rgba(30, 136, 229, 0.12)",
    panelBg: "rgba(12, 17, 28, 0.72)",
    panelBorder: "rgba(255, 255, 255, 0.09)",
    panelShadow:
      "0 0 0 1px rgba(30, 136, 229, 0.14), 0 20px 50px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
    cardShadow:
      "0 8px 28px rgba(0, 0, 0, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.04)",
  },
};

export default ADMIN_THEME;
